<template>
  <div v-if="isMounted">
    <section class="section-chechout">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4">
            <n-button
              :style="myTheme.customizeButton"
              type="primary"
              @click="onAddMoreItems"
              round
              block
              >{{ $t('button.add_more_items') }}</n-button
            >
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4">
            <cart-details
              :action="btnAction"
              :cart="cart"
              :hide="false"
              :showTable="true"
            ></cart-details>
          </div>
        </div>
      </div>
    </section>
    <order-changes-confirmation
      ref="popupConfirmation"
    ></order-changes-confirmation>
    <order-modal
      ref="itemModal"
      :fromItem="fromItem"
      :editMode="editMode"
      :index="index"
      :orderType="cart.orderType"
    ></order-modal>
  </div>
</template>
<script>
import { Button } from "@/components";
import { CartDetails, OrderModal } from "./components";
import { cartManager, enumHelper, helpers } from "@/utilities";
import { OrderChangesConfirmation } from "@/layout";
import router from "@/router";
export default {
  name: "cart",
  components: {
    CartDetails,
    [Button.name]: Button,
    OrderModal,
    OrderChangesConfirmation,
  },
  data() {
    return {
      index: -1,
      fromItem: null,
      editMode: false,
      btnAction: enumHelper.actions.CHECKOUT,
      cart: cartManager.InitCart(),
      isMounted: false,
    };
  },
  methods: {
    addItemToOrder(_currentItem, _openModal = false) {
      if (_openModal) {
        if (!this.editMode) {
          this.fromItem = JSON.parse(JSON.stringify(_currentItem));
          this.fromItem.quantity = 1;
          if (this.fromItem.hasOptions) {
            this.fromItem.options.forEach((element) => {
              element.selected = [];
              element.comment = "";
            });
          }
        } else {
          this.fromItem = _currentItem;
        }
        //--- geive the Modal the Data and Open-it
        this.$refs.itemModal.openModal();
      } else {
        //cartManager.setCart(_currentItem);
        cartManager.setCart(this.cart);
        this.$notify({
          group: "bottomRight",
          title: "Item Added",
          type: "success",
          text:
            _currentItem.name +
            " item has been added to your order.",
        });
        this.$refs.itemModal.closeModal();
      }
      this.addEventListener()
    },
    removeItem(_index) {
      //---- get the card
      let itemToDelete = this.cart.order[_index];
      this.$delete(this.cart.order, _index);

      cartManager.setCart(this.cart);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
      this.$notify({
        group: "bottomRight",
        title: this.$t("message.item_removed_notify_title"),
        type: "warn",
        text: this.$t("message.item_removed_notify_message", { item_name : itemToDelete.name})
      });

      if (this.editMode) this.$refs.itemModal.closeModal();
      this.removeEventListner()
    },
    removeItems(arrItems) {
      //---- get the card
      this.cart.order = this.cart.order.filter((x) => !arrItems.includes(x.id));
      cartManager.setCart(this.cart);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
      this.removeEventListner()
    },
    addEventListener: function() {
      this.$root.$off("PUSH_ITEM");
      this.$root.$on("PUSH_ITEM", (_object) => {
        this.index = _object.index;
        this.editMode = _object.editMode;
        this.addItemToOrder(_object.item, _object.openModal);
      });
    },
    removeEventListner: function() {
      this.$root.$off("REMOVE_ITEM");
      this.$root.$on("REMOVE_ITEM", (_index) => {
        this.removeItem(_index);
      });

      this.$root.$off("REMOVE_ITEMS");
      this.$root.$on("REMOVE_ITEMS", (arrItems) => {
        this.removeItems(arrItems);
      });
    },
    openPopUpConfirmationEventListner: function() {
      this.$root.$off("OPEN_POPUP_CONFIRMATION");
      this.$root.$on("OPEN_POPUP_CONFIRMATION", (data) => {
        this.$refs.popupConfirmation.ItemsNotAvailable = data.ItemsNotAvailable;
        this.$refs.popupConfirmation.ItemsWithDiffPrice =
          data.ItemsWithDiffPrice;
        this.$refs.popupConfirmation.shown = true;
        this.$refs.popupConfirmation.newOrderType = data.NewOrderType;
        this.$refs.popupConfirmation.oldOrderType = data.OldOrderType;
      });
    },
    onAddMoreItems() {
      router.push("/menu");
    },
    setCartDeliveryFee() {
      return new Promise((resolve) => {
        if (
          this.cart.orderType == enumHelper.orderType.Delivery &&
          this.selectedLocation.delivery_condition &&
          this.selectedLocation.availabe_delivery_postcode
        ) {
          if (this.cart.order.length)
            // call this method if the cart total is > to 0
            this.cart.delivery_fee = helpers.getDeliveryFee(
              this.selectedLocation.delivery_condition,
              this.cart.total
            );
          else {
            this.cart.delivery_fee = helpers.getDefaultDeliveryFee(
              this.selectedLocation.delivery_condition
            );
          }
          cartManager.setCart(this.cart, true, false);
          resolve(true);
        }
        resolve(false);
      });
    },
    refreshCartDataListner(){
      this.$root.$off("REFRESH_CART_DATA");
      this.$root.$on("REFRESH_CART_DATA", () => {
        this.cart = cartManager.getCart();
      });
    }
  },
  created: function() {
    //---- init the localStorage
    this.refreshCartDataListner();
    this.addEventListener();
    this.removeEventListner();
    this.openPopUpConfirmationEventListner();
    this.cart = cartManager.InitCart();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
